// extracted by mini-css-extract-plugin
export default {"Container":"Tabs_Container__KfEVp","Tabs":"Tabs_Tabs__WoN9e"};